import { setLocale } from 'yup';
import formsLocale from './forms';

setLocale(formsLocale);
